import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterRoutingModule } from './register-routing.module';
import { RegisterComponent } from './register.component';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../material.module';
import {GenericModalModule} from '../modal/generic-modal.module';
import {NgxSelectModule} from 'ngx-select-ex';
@NgModule({
    imports: [
        CommonModule,
        RegisterRoutingModule,
        FormsModule,
        MaterialModule,
        GenericModalModule,
        NgxSelectModule
    ],
  declarations: [RegisterComponent],
  providers: [],
  exports: [RegisterComponent]
})

export class RegisterModule {

}
